<template>
  <div>
    <div v-if="info.msgWithdrawStatus===0">
      <!--普通文本-->
      <div v-if="info.csdrType===31">
        <p class="talkMsg" :style="{webkitLineClamp:info.lineLimit}">{{ info.csdrContent }}</p>
        <span class="watchDetail" v-if="info.csdrContent.length>105&&info.lineLimit!=='inherit'"
              @click="watchDetail">查看</span>
      </div>
      <!--富文本-->
      <p v-if="info.csdrType===32" v-html="info.csdrContent" class="richText"></p>
      <!--图片-->
      <img v-if='info.csdrType===42' :src="$originApi+info.csdrAtt" @click="showImg($originApi+info.csdrAtt)"
           class="imgMsg">
      <!--附件-->
      <attachment v-if="info.csdrType===41" :fileInfo="info"></attachment>
    </div>
    <p v-if="info.msgWithdrawStatus===1">{{ info.msgWithdrawHint }}</p>
  </div>
</template>

<script>
import attachment from '@/components/chat/attachment'
import {ImagePreview} from 'vant'
import {getLoginInfo} from '../../util/auth'

export default {
  name: 'msgType',
  props: ['info'],
  components: {attachment},
  data () {
    return {
      loginInfo: getLoginInfo()
    }
  },
  methods: {
    // 查看大图
    showImg (img) {
      ImagePreview([img])
    },
    // 打开评价弹窗
    openEvaluate () {
      this.showEvaluate = true
    },
    // 查看当前聊天消息全部信息
    watchDetail () {
      this.info.lineLimit = 'inherit'
    }
  }
}
</script>

<style scoped>
.imgMsg {
  width: 150px;
}

.watchDetail {
  color: #448af7;
  font-size: 14px;
}

.call {
  color: #1e90ff;
}

.evaluateButton {
  color: #1e90ff;
}

.evaluate {
  width: 22px;
  vertical-align: middle;
}

.richText {
  white-space: pre-wrap;
}

/deep/ .richText ol {
  padding-left: 15px;
  list-style: decimal !important;
}

/deep/ .richText ul {
  padding-left: 15px;
  list-style-type: disc !important;
}

/deep/ .richText img {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/msgType.vue